import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GlobalConfigurationsComponent } from './global-configurations/global-configurations.component';
import { PlatformsTabComponent } from './platforms-tab/platforms-tab.component';

export interface AccountPolicyTab {
  id: string;
  label: string;
}

@Component({
  selector: 'app-account-policy',
  templateUrl: './account-policy.component.html',
  styleUrls: ['./account-policy.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GlobalConfigurationsComponent, PlatformsTabComponent],
})
export class AccountPolicyComponent {
  public tabs: AccountPolicyTab[] = [
    { id: 'global-configurations', label: 'Global configurations' },
    { id: 'platforms', label: 'Platforms' },
  ];

  public selectedTabId = 'global-configurations';

  public onTabSelect(tabId: string): void {
    this.selectedTabId = tabId;
  }

  public isTabSelected(tabId: string): boolean {
    return this.selectedTabId === tabId;
  }
}
